'use client';

import { Suspense } from 'react';
import { LoginLayout } from '@/features/auth/components/LoginLayout';

export function LoginBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Suspense fallback={<div className="min-h-screen" />}>
      <LoginLayout>{children}</LoginLayout>
    </Suspense>
  );
}